import { render, staticRenderFns } from "./EmptyCart.vue?vue&type=template&id=09b64c3e"
import script from "./EmptyCart.vue?vue&type=script&lang=js"
export * from "./EmptyCart.vue?vue&type=script&lang=js"
import style0 from "./EmptyCart.vue?vue&type=style&index=0&id=09b64c3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports